module.exports = __webpack_public_path__ + "static/media/kiwi.3b4349c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/kiwi.png
// module id = 38
// module chunks = 0